import { render, staticRenderFns } from "./CampaignSidebar.vue?vue&type=template&id=4cfb36e8&scoped=true&"
import script from "./CampaignSidebar.vue?vue&type=script&lang=ts&"
export * from "./CampaignSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignSidebar.vue?vue&type=style&index=0&id=4cfb36e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfb36e8",
  null
  
)

export default component.exports